const contactData = [
    {
        id: "1",
        icon: require("../../assets/icons/solar_phone-outline.svg").default,
        title: "Phone Number",
        value: "050 233 4 995",
        link: "tel:050 233 4 995",
        text: "Call us during business hours"
    },
    {
        id: "2",
        icon: require("../../assets/icons/material-symbols_mail-outline.svg").default,
        title: "Email Address",
        value: "Mapartner@outlook.com",
        link: "mailto:Mapartner@outlook.com",
        text: "Send us your inquiries anytime"
    },
    {
        id: "3",
        icon: require("../../assets/icons/mi_location.svg").default,
        title: "Office Address",
        value: "Al Wahda Commercial Tower, Office No. 101",
        link: "https://www.google.com/maps?q=24.4721527099609,54.3742027282715",
        text: "Office No: 101, Abu Dhabi, UAE"
    },
    {
        id: "4",
        icon: require("../../assets/icons/mingcute_time-line.svg").default,
        title: "Business Hours",
        value: "Sunday - Thursday",
        link: null,
        text: "9:00 AM - 6:00 PM (GST)"
    },
]

export default contactData;